<template>
  <span class="scaling-svg-container">
    <svg class="scaling-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="10.659" viewBox="0 0 16 10.659">
      <path
        d="M13.543,10.467a.657.657,0,0,1,0-.929l.87-.87-.87-.87a.657.657,0,1,1,.929-.93L15.808,8.2a.657.657,0,0,1,0,.929l-1.336,1.335a.657.657,0,0,1-.929,0ZM2.159,9.325A2.161,2.161,0,0,1,0,7.166V2.159A2.161,2.161,0,0,1,2.159,0H12.506a2.161,2.161,0,0,1,2.158,2.159V5.33a.657.657,0,1,1-1.314,0V3.65H1.314V7.166a.846.846,0,0,0,.845.844h9.846a.657.657,0,0,1,0,1.315ZM1.314,2.159v.177H13.351V2.159a.846.846,0,0,0-.844-.845H2.159A.846.846,0,0,0,1.314,2.159Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PaymentAddIcon extends Vue {}
</script>

<style>
</style>
